// extracted by mini-css-extract-plugin
module.exports = {"root":"TagsGroup_root__Dzo29","compact":"TagsGroup_compact__6zGY4","item":"TagsGroup_item__yRsMW","tag":"TagsGroup_tag__EX9T1"};